import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import artePropTypes from '../../propTypes';
import Sticker from '../../UI/Sticker/Sticker';
import Interchange from '../../UI/Interchange/Interchange';
import { StyledLink } from './TeaserLandscape.css';
import Icon from '../../UI/Icon/Icon';
import { hovers, remCalc, palette } from '../../css';

const IconContainer = styled('div')(({ isIconLeft }) => {
    const commonStyles = {
        position: 'absolute',
        color: palette('white'),
        top: remCalc(8),
    };
    return isIconLeft
        ? {
              ...commonStyles,
              left: remCalc(10),
          }
        : { ...commonStyles, right: remCalc(10) };
});

const TeaserLandscape = ({
    broadcastDate,
    className,
    hover,
    iconKind,
    images,
    placeholder,
    stickerPosition,
    title,
    titlesElement,
    isIconLeft,
    url,
}) => (
    <div className={classnames(className, { 'is-placeholder': placeholder })}>
        <StyledLink href={url}>
            <Interchange images={images} hover={hovers[hover]} placeholder={placeholder} title={title} />
            {broadcastDate && <Sticker position={stickerPosition} label={broadcastDate} />}
            {iconKind ? (
                <IconContainer isIconLeft={isIconLeft}>
                    <Icon name={artePropTypes.kindMap[iconKind]} size="custom" title={iconKind} />
                </IconContainer>
            ) : null}
            {titlesElement}
        </StyledLink>
    </div>
);

TeaserLandscape.propTypes = {
    broadcastDate: PropTypes.string,
    className: PropTypes.string,
    hover: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    placeholder: PropTypes.bool,
    iconKind: PropTypes.string,
    isIconLeft: PropTypes.bool,
    stickerPosition: PropTypes.string,
    title: PropTypes.string.isRequired,
    titlesElement: PropTypes.node,
    url: PropTypes.string.isRequired,
};

TeaserLandscape.defaultProps = {
    className: 'next-teaser',
    hover: 'basic',
    iconKind: null,
    isIconLeft: false,
    placeholder: false,
    stickerPosition: 'top-right',
    titlesElement: null,
};

export default TeaserLandscape;
